export default "__VITE_PUBLIC_ASSET__6251415c__"